import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import CRMOnly from "./middlewares/CRMOnly";
import CRMRouter from "./CRMRouter";
import SidebarLayout from "layouts/SidebarLayout";

import CRMAppBar from "components/AppBar/CRMAppBar";
import CRMSidebar from "components/Sidebar/CRMSidebar";
import ClientSidebar from "components/Sidebar/ClientSidebar";
import ReferralSidebar from "components/Sidebar/ReferralSidebar";
import VendorSidebar from "components/Sidebar/VendorSidebar";
import ContractorSidebar from "components/Sidebar/ContractorSidebar";
import DriverSidebar from "components/Sidebar/DriverSidebar";
import CustomerSidebar from "components/Sidebar/CustomerSidebar";
import { NotFoundScreen } from "screens/NotFoundScreen";
import UserProfileScreen from "screens/App/CRM/User/profile/UserProfileScreen";
import EditUserProfileScreen from "screens/App/CRM/User/profile/EditUserProfileScreen";
import ChangePasswordScreen from "screens/App/CRM/User/profile/ChangePasswordScreen";

import { useAuth } from "hooks/useAuth";
import { onUserOnline } from "socket/socketEvents";
import ContractorOnly from "./middlewares/ContractorOnly";
import VendorOnly from "./middlewares/VendorOnly";
import { ContractorSidebarRouter } from "./ContractorSidebarRouter";
import { VendorSidebarRouter } from "./VendorSidebarRouter";
import DriverOnly from "./middlewares/DriverOnly";
import { DriverSidebarRouter } from "./DriverSidebarRouter";
import CustomerOnly from "./middlewares/CustomerOnly";
import { CustomerSidebarRouter } from "./CustomerSidebarRouter";
import VendorAppBar from "components/AppBar/CRMAppBar/VendorAppBar";
import VendorStaffOnly from "./middlewares/VendorStaffOnly";
import VendorStaffSidebar from "components/Sidebar/VendorStaffSidebar";
import { VendorStaffSidebarRouter } from "./VendorStaffSidebarRouter";
import { DeleteAccountScreen } from "screens/App/CRM/User/DeleteAccountScreen";
import MyDayScreen from "screens/App/CRM/User/profile/MyDayScreen";

const AppRouter = () => {
  const {
    isAdmin,
    isSystem,
    isClient,
    isReferral,
    isContractor,
    isVendor,
    loggedInUser,
    isDriver,
    isVendorStaff,
    isCustomer,
  } = useAuth();

  // Select sidebar based on user type
  const sidebarProps = React.useMemo(() => {
    let sidebar, appBarContent;

    if (isAdmin || isSystem) {
      sidebar = CRMSidebar;
      appBarContent = CRMAppBar;
    } else if (isContractor) {
      sidebar = ContractorSidebar;
    } else if (isVendor) {
      sidebar = VendorSidebar;
      appBarContent = VendorAppBar;
    } else if (isClient) {
    } else if (isDriver) {
      sidebar = DriverSidebar;
    } else if (isClient) {
      sidebar = ClientSidebar;
    } else if (isReferral) {
      sidebar = ReferralSidebar;
    } else if (isCustomer) {
      sidebar = CustomerSidebar;
    } else if (isVendorStaff) {
      sidebar = VendorStaffSidebar;
    }

    return { sidebar, appBarContent };
  }, [
    isAdmin,
    isSystem,
    isContractor,
    isVendor,
    isClient,
    isDriver,
    isReferral,
    isVendorStaff,
    isCustomer,
  ]);

  React.useEffect(() => {
    if (loggedInUser) onUserOnline(loggedInUser);
  }, [loggedInUser]);

  return (
    <Routes>
      <Route element={<SidebarLayout {...sidebarProps} />}>
        <Route index element={<Navigate to="crm" replace />} />

        <Route path="/me">
          <Route index element={<UserProfileScreen />} />
          <Route path="my-day" element={<MyDayScreen />} />
          <Route path="change-password" element={<ChangePasswordScreen />} />
          <Route path="update" element={<EditUserProfileScreen />} />
          <Route path="*" element={<NotFoundScreen />} />
        </Route>

        <Route path="crm/*" element={<CRMOnly component={CRMRouter} />} />
        <Route
          path="contractor/*"
          element={<ContractorOnly component={ContractorSidebarRouter} />}
        />
        <Route
          path="vendor/*"
          element={<VendorOnly component={VendorSidebarRouter} />}
        />
        <Route
          path="contractor/*"
          element={<ContractorOnly component={ContractorSidebarRouter} />}
        />
        <Route
          path="driver/*"
          element={<DriverOnly component={DriverSidebarRouter} />}
        />
        <Route
          path="customer/*"
          element={<CustomerOnly component={CustomerSidebarRouter} />}
        />
        <Route
          path="staff/*"
          element={<VendorStaffOnly component={VendorStaffSidebarRouter} />}
        />

        <Route path="*" element={<NotFoundScreen />} />
      </Route>
      <Route path="/delete" element={<DeleteAccountScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default AppRouter;
